/**
 * Constants for e2e tests
 */

export const TEST_INITIAL_VALUES = {
  GOLD: 1_000_000,
  TICK_LENGTH: 100,
} as const;

export const TEST_TIMEOUTS = {
  SHORT: 5000,
  MEDIUM: 10000,
  LONG: 30000,
  VERY_LONG: 60000,
} as const;

export const GAME_SELECTORS = {
  CANVAS: '#game',
  CANVAS_WRAPPER: '#canvas-wrapper',
  PLAY_BUTTON: '#excalibur-play',
  DIALOG_WRAPPER: '[data-testid="dialog-wrapper"]',
} as const;

export const GAME_URLS = {
  LOCAL: 'http://localhost:5173',
  BASE: '/',
} as const;

export const WAIT_INTERVALS = {
  SHORT: 100,
  MEDIUM: 250,
  LONG: 500,
} as const;
